import { render, staticRenderFns } from "./HistoryRetur.vue?vue&type=template&id=ef401262&scoped=true&"
import script from "./HistoryRetur.vue?vue&type=script&lang=js&"
export * from "./HistoryRetur.vue?vue&type=script&lang=js&"
import style0 from "./HistoryRetur.scss?vue&type=style&index=0&id=ef401262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef401262",
  null
  
)

export default component.exports